import { orderBy, mapValues, map, filter, find } from 'lodash';

export function toSelectionFormat(collection, sortBy = i => (i.name || i.fullName || '').toLowerCase(), order = 'asc') {
    return orderBy(collection || [], sortBy, order).map(i => ({ label: i.name || i.fullName || '', value: i.id }));
}

export function selectionOptionToLabel(value, options) {
    const item = find(options, o => o.value === value);
    return item && item.label;
}

export function clearNullValues(object) {
    return mapValues(object, v => (v === null ? '' : v));
}

export function selectedFromOptionsToString(allOptions = [], selectedOptions = []) {
    return map(
        filter(allOptions, org => selectedOptions.includes(org.value || org.id)),
        org => org.label || org.name
    ).join(', ');
}
